import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import * as aws from 'aws-sdk';
import {from, Observable} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';

@HookClass('aws.kinesis')
export class AwsKinesisHook extends BaseHook {

    // @Hook('43e627eb-54bd-4c53-ba29-6ad85c0b97f7')
    // public createChannel(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
    //     return this.settings
    //         .pipe(concatMap((settings) => {
    //
    //             const kinesis = new aws.KinesisVideo({
    //                 region: 'us-east-1',
    //                 apiVersion: '2017-09-30',
    //                 credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
    //             });
    //
    //             return from(kinesis
    //                 .createSignalingChannel({
    //                     ChannelName: inputArtifact.object.data.channelId
    //                 }).promise())
    //                 .pipe(concatMap(() => {
    //                     return from(kinesis
    //                         .describeSignalingChannel({
    //                             ChannelName: inputArtifact.object.data.channelId
    //                         })
    //                         .promise());
    //                 })).pipe(map((channel: any) => {
    //                     return channel.ChannelInfo.ChannelARN;
    //                 }));
    //         }));
    // }
    //
    // @Hook('9ffa86ed-b702-4865-a57d-5e85d4e1d55c')
    // public createMaster(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
    //     return this.settings
    //         .pipe(concatMap((settings) => {
    //
    //             const kinesisVideoClient = new aws.KinesisVideo({
    //                 region: 'us-east-1',
    //                 apiVersion: '2017-09-30',
    //                 credentials: {accessKeyId: settings.aws.accessKeyId, secretAccessKey: settings.aws.secretAccessKey}
    //             });
    //
    //             // Get signaling channel ARN
    //             return from(kinesisVideoClient
    //                 .describeSignalingChannel({
    //                     ChannelName: inputArtifact.object.data.channelId
    //                 })
    //                 .promise())
    //                 .pipe(concatMap((channel: any) => {
    //                     const channelARN = channel.ChannelInfo.ChannelARN;
    //
    //                     return from(kinesisVideoClient
    //                         .getSignalingChannelEndpoint({
    //                             ChannelARN: channelARN,
    //                             SingleMasterChannelEndpointConfiguration: {
    //                                 Protocols: ['WSS', 'HTTPS'],
    //                                 Role: 'MASTER'
    //                             }
    //                         })
    //                         .promise());
    //                 }))
    //                 .pipe(map((getSignalingChannelEndpointResponse: any) => {
    //                     return getSignalingChannelEndpointResponse.ResourceEndpointList.reduce((endpoints: any, endpoint: any) => {
    //                         endpoints[endpoint.Protocol] = endpoint.ResourceEndpoint;
    //                         return endpoints;
    //                     }, {});
    //                 }));
    //         }));
    // }
}
